import React from "react"

import Shape9 from "../../assets/images/shape/shape9.webp"
import Shape10 from "../../assets/images/shape/shape10.webp"
import Shape11 from "../../assets/images/shape/shape11.webp"
import Shape12 from "../../assets/images/shape/shape12.webp"

const SubscribeForm = () => {
  return (
    <>
      <div className="subscribe-area ptb-100">
        <div className="container">
          <div className="subscribe-content">
            <span
              className="sub-title"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              APCV News
            </span>

            <h2
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              Đăng ký nhận tin tức mới nhất
            </h2>

            <p data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
              Đăng ký để nhận thông tin mới nhất về các sản phẩm và dịch vụ của APCV,
              chia sẻ kiến thức về học sâu và thị giác máy tính.
            </p>

            <form
              className="newsletter-form"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="400"
            >
              <input
                type="text"
                className="input-newsletter"
                placeholder="Enter your email address"
                name="EMAIL"
                required
              />
              <button type="submit" className="default-btn">
                Gửi
              </button>
            </form>
          </div>
        </div>

        <div className="shape9">
          <img src={Shape9} alt="Shape" />
        </div>
        <div className="shape10">
          <img src={Shape10} alt="Shape" />
        </div>
        <div className="shape11">
          <img src={Shape11} alt="Shape" />
        </div>
        <div className="shape12">
          <img src={Shape12} alt="Shape" />
        </div>
      </div>
    </>
  )
}

export default SubscribeForm
